import { defineStore } from 'pinia'
import LocationsState, { LocationsStateType } from './state'
import { LocationsActions, LocationsActionsType } from './actions'
import { LocationsGetters } from './getters'

export const useLocationsStore = defineStore<
  'locations',
  LocationsStateType,
  typeof LocationsGetters,
  LocationsActionsType
>('locations', {
  state: LocationsState,
  actions: LocationsActions,
  getters: LocationsGetters,
})
